export const Logo = ({ size = 'md', variant = 'web' }) => {
  const heights = { sm: 48, md: 64, lg: 96, xl: 128, '2xl': 192, '3xl': 260 };
  // variant: 'web' = OttoMed + ottomed.org tagline (for navbars)
  //         'invoice' = OttoMed + "Support in Every Step" (for landing/PDF/emails)
  // PNGs are pre-processed to have a transparent background — so the logo
  // sits cleanly on any page color without any visible rectangle.
  const src = variant === 'invoice' ? '/ottomed-invoice-logo.png' : '/ottomed-logo.png';
  return (
    <img
      src={src}
      alt="OttoMed"
      style={{
        height: `${heights[size]}px`,
        width: 'auto',
        display: 'inline-block',
        maxWidth: '100%',
      }}
      draggable={false}
      data-testid="ottomed-logo"
    />
  );
};

export default Logo;
